import React from 'react';
import _ from 'lodash';
import autoBind from 'react-autobind';
import SectionHeader from '../SectionHeader.jsx';
import Classnames from 'classnames';
import {YesNoValues} from '../../../constants/ApplicationConstants.js';
import Products from '../../../utils/Products.js';
import FundingYourProductConstants from '../../../constants/FundingYourProductConstants.js';

export default class FundingYourProductReview extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    _renderHeader() {
        return (
            <SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.sectionName}/>
        );
    }

    _renderSubSectionMessages() {
        let sectionParagraphs = [];

        if (this.props.sectionParagraph) {
            sectionParagraphs.push(this.props.sectionParagraph);
        }
        if (this.props.hasTermDeposit) {
            sectionParagraphs.push(FundingYourProductConstants.termDepositInstructionNote);
        }
        const hasMessages = this.props.sectionMessage.length > 0 && sectionParagraphs.length > 0;
        return hasMessages
                ? (<div className="row simple-review-row-subsection">
                    <div className="col-xs-12">
                        <div>{this.props.sectionMessage}</div>
                            { sectionParagraphs.length > 0 ? 
                                sectionParagraphs.map((p, idx) => {
                                    return (<div key={`fyp_confirm_${idx}_paragraph`}>{p}</div>);
                                }) : null }
                    </div>
                </div>)
                : null;
    }

    _renderRow(col1, col2, col3) {
        return (
            <div className="row">
                <div className="col-xs-5">
                    {col1}
                </div>
                <div className="col-xs-2 text-right">
                    {col2}
                </div>
                <div className="col-xs-5">
                    {col3}
                </div>
            </div>
        );
    }

    _renderFyp(item, index) {
        let rollOverName = <span className="label-header"><span className="workItem__hidden">{index + 1}. </span>{item.rollOverName}</span>;
        let rollOverTypeLabel = <span>{item.rollOverTypeLabel}</span>;
        let amountValue = <div><span className="pull-left">$</span><span className="confirm-fyp__currency">{item.amountValue}</span></div>;
        let acc = <span className="confirm-fyp__account">{item.accountNumber}</span>;
        let remainingBalanceLabel = <span className="remaining-balance">{item.remainingBalanceLabel}</span>;
        let remainingBalanceValue = (item.remainingBalanceLabel) ? <div className="remaining-balance"><span className="pull-left">$</span><span className="confirm-fyp__currency">{item.remainingBalanceValue}</span></div>
            : <span>{item.remainingBalanceValue}</span>;
        let transferInsuranceLabel = <span>{item.transferInsuranceLabel}</span>;
        let transferInsuranceValue = <span>{item.transferInsuranceValue}</span>;
        const getId = _.camelCase(item.rollOverName);

        return (
            <div key={`fyp_confirm_${index}_row`} className="confirm-fyp simple-review-row-subsection" id={getId}>
                {this._renderRow(rollOverName, rollOverTypeLabel, amountValue) }
                {this._renderRow(acc, remainingBalanceLabel, remainingBalanceValue) }
                {(item.transferInsuranceLabel || item.transferInsuranceValue) ? 
                    this._renderRow(null, transferInsuranceLabel, transferInsuranceValue) : null}
            </div>);
    }
    _renderTotal() {
        return (
            <div key={`fyp_confirm_total`} className="confirm-fyp simple-review-row-subsection" id="fypConfirmTotal">
                {this._renderRow(null, <span>Approximate total</span>, <div className="label-header"><span className="pull-left">$</span><span className="confirm-fyp__currency">{this.props.total}</span></div>) }
            </div>
        );
    }
    _renderTaxClaim(answer) {
        return (
            <div className="row">
                <div className="col-xs-4"><span>Will you be claiming a tax deduction</span></div>
                <div className="col-xs-8"><span className="simple-review-value">{answer}</span></div>
            </div>
        );
    }
    _renderTaxClaimMessage(taxDeductionMessage) {
        const html = { __html: taxDeductionMessage };
        return (
            <div className="row" id="taxDeductionMessage">
                <div className="col-xs-12">
                    <p></p>
                    <p dangerouslySetInnerHTML={html}></p>
                </div>
            </div>
        );
    }
    _renderBankAccountDetails() {
        return (
            <div id="bankAccountDetails">
                <div>
                <div className="row">
                    <div className="col-xs-12 label-header">
                        <span>Direct debited from</span>
                    </div>
                </div>
                {this.props.bankAccountDetails.map((item, index) => {
                    const colClass = Classnames('row', { 'simple-review-row-subsection': item.subsection }, { 'simple-review-row': !item.subsection });

                    return (
                        <div key={`fyp_confirm_${index}_row`} className={colClass}>
                            <div className="col-xs-4">
                                <span>{ item.label }</span>
                            </div>
                            <div className="col-xs-8">
                                <span className="simple-review-value">{ item.value }</span>
                            </div>
                        </div>)
                }) }
            </div>
            </div>
        )
    }
    render() {
        let taxClaim = '';
        let isPersonalContribution = _.find(this.props.items, { rollOverName: FundingYourProductConstants.FundTypesLabel['Personal_contribution'] });

        if (Products.isPension(this.props.productId) && isPersonalContribution) {
            taxClaim = this.props.hasTaxClaim ? this._renderTaxClaim(YesNoValues.YES_LONG) : this._renderTaxClaim(YesNoValues.NO_LONG);
        }

        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    {this._renderHeader() }
                    {this._renderSubSectionMessages()}
                    {this.props.items.map(this._renderFyp, this) }
                    {this._renderTotal() }
                    {taxClaim}
                    {this.props.hasTaxClaim ? this._renderTaxClaimMessage(this.props.taxDeductionMessage) : null}
                    {this.props.bankAccountDetails && this.props.bankAccountDetails.length > 0 ? this._renderBankAccountDetails() : null}
                </div>
            </section>);
    }
}

FundingYourProductReview.propTypes = {
    items: React.PropTypes.array.isRequired,
    sectionName: React.PropTypes.string.isRequired,
    sectionId: React.PropTypes.string,
    sectionMessage: React.PropTypes.string,
    total: React.PropTypes.string.isRequired,
    hasTaxClaim: React.PropTypes.bool.isRequired,
    bankAccountDetails: React.PropTypes.array.isRequired
};

FundingYourProductReview.defaultProps = {
    sectionMessage: ''
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/FundingYourProduct/FundingYourProductReview.jsx